var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    stroke: "#14753B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.56975,
    cy: 3.56975,
    r: 0.714286,
    fill: "#14753B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.42522,
    cy: 3.56975,
    r: 0.714286,
    fill: "#14753B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 5.99881C6.19385 6.71306 4.6463 7.71302 3.21779 5.99881",
    stroke: "#14753B",
    strokeWidth: 0.999955,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveIcon);
export default __webpack_public_path__ + "static/media/positive-icon.7e8064eaddf2ad8b3d2a54740f0493c7.svg";
export { ForwardRef as ReactComponent };